// Created once: building a formatter is slow and the dashboard formats thousands of amounts
const currencyFormat = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 2, style: 'currency', currency: 'AUD', currencySign: 'accounting' });

export function formatNumber(number: number) {
  return currencyFormat.format(number || 0);
}

export function getRandomInt(max: number = Number.MAX_SAFE_INTEGER) {
  return Math.floor(Math.random() * max);
}
